import { render } from "./Label.vue?vue&type=template&id=4f983ae8&scoped=true"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import "./Label.vue?vue&type=style&index=0&id=4f983ae8&scoped=true&lang=css"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f983ae8"],['__file',"backend/vue/imagecontentpluginform/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f983ae8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f983ae8', __exports__)) {
    api.reload('4f983ae8', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=4f983ae8&scoped=true", () => {
    api.rerender('4f983ae8', render)
  })

}


export default __exports__